import { render, staticRenderFns } from "./myStudy.vue?vue&type=template&id=29f9fbb4&scoped=true"
import script from "./myStudy.vue?vue&type=script&lang=js"
export * from "./myStudy.vue?vue&type=script&lang=js"
import style0 from "./myStudy.vue?vue&type=style&index=0&id=29f9fbb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f9fbb4",
  null
  
)

export default component.exports